import React from "react";
import LocalizedText from "../../../presentational/LocalizedText";
import ProgressIndicator from "../SurveyProgressIndicator/SurveyProgressIndicator";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/pro-solid-svg-icons";
import "./SurveyHeader.css";
import UnstyledButton from "../../../presentational/UnstyledButton/UnstyledButton";
import { SurveyDefinition, SurveyStepDefinition } from "../../../../types/Survey";

export interface SurveyHeaderProps {
    onBack: () => void;
    onContinue: () => void;
    onSaveAndClose: () => void;
    onClose: () => void;
    canGoBack: boolean;
    showSaveAndClose: boolean;
    showCancelButton: boolean;
    stepDefinition: SurveyStepDefinition;
    surveyDefinition: SurveyDefinition;
}

export default function (props: SurveyHeaderProps) {
    if (!props.stepDefinition) { return null; }

    return <div className="survey-header" style={{ backgroundColor: { ...props.surveyDefinition.styles, ...props.stepDefinition.styles }.backgroundColor }}>
        {props.canGoBack &&
            <UnstyledButton className="back-button" onClick={() => props.onBack()}><FontAwesomeIcon icon={faChevronLeft} /> <LocalizedText textKey="back-button-text" /></UnstyledButton>
        }
        <ProgressIndicator
            surveyDefinition={props.surveyDefinition}
            stepDefinition={props.stepDefinition} />
        {props.showSaveAndClose &&
            <UnstyledButton className="save-exit-button" onClick={() => props.onSaveAndClose()}>
                <LocalizedText textKey="save-and-exit-button-text" />
            </UnstyledButton>
        }
        {props.stepDefinition.type !== "CompletionStep" && props.showCancelButton &&
            <UnstyledButton className="cancel-button" onClick={() => props.onClose()}>
                {!props.surveyDefinition.cancelButtonLabel &&
                    <LocalizedText textKey="cancel-button-text" />
                }
                {props.surveyDefinition.cancelButtonLabel &&
                    <span>{props.surveyDefinition.cancelButtonLabel}</span>
                }
            </UnstyledButton>
        }
        {props.stepDefinition.type === "CompletionStep" &&
            <UnstyledButton className="done-button" onClick={() => props.onContinue()}>
                <LocalizedText textKey="done-button-text" />
            </UnstyledButton>
        }
    </div>;
}